/* eslint-disable max-len */
import React, { Fragment } from 'react'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector ,useDispatch} from 'react-redux';
import OrgMonitorTableBody from './TableBody';


const OrgMonitorTable=({pageNumber,List,handleSearchParams,sortValue,setisSortSelected,setConfirmationState,setTextAreaMsg,handleSearchClose})=>{
    const [searchParams,setSearchParams]=useSearchParams()
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const selectedRows=useSelector((state)=>state?.MultiSelectSlice?.selectedRows)
    const urlParams = new URLSearchParams(window.location.search);
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    return(
        <div>
            <div className='h-[calc(100vh-276px)] 2xl:h-[calc(100vh-274px)] overflow-auto scrollbar_purple pb-2.5' onScroll={()=>setSelectedIndex('')}>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">ID
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Username
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[200px]"  >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">First Name
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[160px]" >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Last Name
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[120px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Status
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[120px] rounded-tl-sm rounded-bl-sm flex justify-center">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000] text-center">Action
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item,index)=>(
                            <Fragment key={item._id}>
                                <OrgMonitorTableBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                    handleSearchClose={handleSearchClose}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default OrgMonitorTable